import { render, staticRenderFns } from "./CetakLabel.vue?vue&type=template&id=586a3df3&scoped=true&"
import script from "./CetakLabel.vue?vue&type=script&lang=js&"
export * from "./CetakLabel.vue?vue&type=script&lang=js&"
import style0 from "./CetakLabel.vue?vue&type=style&index=0&id=586a3df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a3df3",
  null
  
)

export default component.exports